import React, {useReducer, useContext, createContext} from 'react';
import * as R from 'ramda';

const useStateHelper = ({handlers}) => {
  const reducer = (state, action) =>
    R.propOr(R.identity, action.type, handlers)(state, action);

  const stateCtx = createContext();

  const StateProvider = ({initialState, children}) => (
    <stateCtx.Provider value={useReducer(reducer, initialState)}>
      {children}
    </stateCtx.Provider>
  );

  const useStateCtx = () => useContext(stateCtx);

  return [StateProvider, useStateCtx];
};

export default useStateHelper;
